'use strict';

import React from 'react'

import Layout   from '@Layout/BackOffice'
import DataList from '@/DataList'
import config   from '@Config/Configuration/place'

export default class PlacesPage extends React.Component
{
	componentWillMount ()
	{
		app.resetFunctions();
	}

	render ()
	{
		const component = this, props = this.props;

		var output =
		(
			<Layout history={ props.history } page_title={ config.title }>

				<div className="page-content">

					<div className="o-content">
						<DataList config={ config } history={ props.history } />
					</div>

				</div> { /* /page-content */ }

			</Layout>
		);

		return output;
	}
}
